<template>
  <div style="max-width: 500px">
    <v-dialog v-model="WoDlg" scrollable width="90vw">
      <v-overlay :value="caricamento_dati">
        <v-icon class="ruota" size="100">mdi-cog</v-icon>
        <v-icon class="controruota" size="100">mdi-cogs</v-icon>
      </v-overlay>

      <v-card id="consuntivo_work_order" flat>
        <v-toolbar class="white--text" color="indigo" dense flat>
          <v-toolbar-title> Seleziona il Work Order </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di avvio multiplo dei WO -->
          <v-btn
            class="ma-5"
            @click="clickAvviaMultiploWO"
            color="success"
            dark
            :disabled="
              items_consuntivo.filter((e) => e.selezionato === true).length ===
              0
            "
            v-if="avvio_multiplo_enabled === 1"
          >
            AVVIO MULTIPLO
          </v-btn>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <WorkorderLayoutComponent
            @button_click="handleButtonClick"
            :items_consuntivo="items_consuntivo"
            ref="WorkorderLayoutComponent"
            style="width: 100%"
            :key="layouKey"
            v-if="items_consuntivo.length > 0 || caricamento_dati == true"
          />
          <div class="mt-5" v-else>
            <span style="font-size: 18px; font-weight: bold">
              Non ci sono Work Order disponibili per questo utente.
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma attivazione -->
    <v-dialog persistent v-model="conferma_dialog" width="unset">
      <v-card>
        <v-toolbar class="white--text" color="indigo" flat>
          <v-toolbar-title>Conferma attivazione</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="font-size: 20px">
          <span
            v-if="
              work_order_sel == null ||
              work_order_sel.messaggio_avvio == undefined
            "
          >
            Vuoi avviare il work order n.
            <b>{{
              work_order_sel == null
                ? ""
                : work_order_sel.cod_commessa + "." + work_order_sel.cod_fase
            }}</b
            >?
          </span>
          <span style="font-size: 20px" v-else>
            {{ work_order_sel == null ? "" : work_order_sel.messaggio_avvio }}
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-btn
          class="mx-2 my-2"
          @click="
            (conferma_dialog = !conferma_dialog),
              (work_order_sel = Object.assign({}))
          "
          color="error"
          dark
          style="font-size: 20px"
        >
          ANNULLA
        </v-btn>
        <v-btn
          class="mx-2 my-2"
          @click="addToCarrello(work_order_sel)"
          color="success"
          dark
          style="font-size: 20px"
        >
          CONFERMA
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma attivazione multipla -->
    <v-dialog persistent v-model="conferma_dialog_avvio_multiplo" width="unset">
      <v-card>
        <v-toolbar class="white--text" color="indigo" flat>
          <v-toolbar-title>Conferma attivazione</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="font-size: 20px">
          Confermi di voler avviare i Work Order selezionati?
        </v-card-text>
        <v-divider></v-divider>
        <v-btn
          class="mx-2 my-2"
          @click="
            (conferma_dialog_avvio_multiplo = !conferma_dialog_avvio_multiplo),
              ($refs.WorkorderLayoutComponent.items_work_orders_sel =
                new Array())
          "
          color="error"
          dark
          style="font-size: 20px"
        >
          ANNULLA
        </v-btn>
        <v-btn
          class="mx-2 my-2"
          @click="addMultipleToCarrello"
          color="success"
          dark
          style="font-size: 20px"
        >
          CONFERMA
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Mini dialog per indicare gli impegni delle macchine -->
    <v-dialog v-model="dialog_impegni" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Impegni </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              dialog_impegni = false;
              conferma_dialog = false;
            "
            small
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-3">
          <div style="display: inline-block; max-width: 500px">
            <span style="font-size: 15px">
              Questo Work Order non è disponibile per il carrello delle
              lavorazioni perché tutte le macchine ad esso associate risultano
              attualmente impegnate:
            </span>
          </div>
          <v-data-table
            :headers="headers_macchine_impegnate"
            hide-default-footer
            :items="items_macchine_impegnate"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="3000">
      {{ snackbar_text }}
      <v-btn
        @click="snackbar = false"
        class="ml-5"
        :color="snackbar_color"
        fab
        outlined
        x-small
        style="background-color: #ffffff"
      >
        <v-icon>{{ snackbar_icon }}</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import WorkorderLayoutComponent from "@/components/WorkorderLayout/WorkorderLayoutComponent.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  props: {
    avvio_multiplo_enabled: {
      type: Number,
      default: 0,
    },
    visible: { type: Boolean, default: false },
  },
  components: {
    WorkorderLayoutComponent,
    SnackbarQV,
  },
  data() {
    return {
      woQuery: "",
      headers_macchine_impegnate: [
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Utente",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "data_inizio",
        },
      ],
      items_macchine_impegnate: new Array(),
      items_consuntivo: [],
      layouKey: true,
      dialog_impegni: false,
      conferma_dialog_avvio_multiplo: false,
      caricamento_dati: false,
      work_order_sel: null,
      conferma_dialog: false,
      WoDlg: true,
      request_counter: 0,
      snackbar: false,
      snackbar_color: "",
      snackbar_icon: "",
      snackbar_text: "",
    };
  },
  watch: {
    request_counter: {
      immediate: true,
      handler() {
        if (this.request_counter <= 0) {
          this.caricamento_dati = false;
        } else {
          this.caricamento_dati = true;
        }
      },
    },
  },
  async mounted() {
    await this.getworkorders();
    this.layouKey = !this.layouKey;
  },
  methods: {
    addToCarrello(arg) {
      /* Controllo che la macchina non sia già
       * impegnata per qualche altro Work Order. */
      if (arg.macchina_impegnata == 1 && arg.multicommessa == 0) {
        this.checkImpegnoMacchine(arg);
        return;
      }

      this.request_counter++;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutente",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Compongo un messaggio con il contenuto del row cliccato.
            let messaggio = {
              detail: {
                work_order_sel: res.data.workorders.workorder[0],
              },
              src: null,
            };

            // Inserisco il messaggio in un evento custom.
            let evento = new CustomEvent("clicked_row", messaggio);

            document
              .getElementById("listener_Produzione2")
              .dispatchEvent(evento);
            this.$emit("inviato_elemento");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }

          // Chiudo il dialog di conferma
          this.conferma_dialog = false;

          // Chiudo l'overlay di caricamento
          this.request_counter--;

          // Salvo i filtri attuali.
          //this.salvaFiltriAttuali();
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    salvaFiltriAttuali() {
      if (
        this.$refs.WorkorderLayoutComponent.filtri != null &&
        this.$refs.WorkorderLayoutComponent.filtri.length > 0
      ) {
        localStorage.filtri_scelta_WO = JSON.stringify(
          this.$refs.WorkorderLayoutComponent.filtri
        );
      }
    },
    checkImpegnoMacchine(arg) {
      const request = {
        controller: "MAGAZZINO",
        method: "POST",
        richiesta: {
          action: "checkworkorder",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_macchine_impegnate = new Array();
            res.data.result.forEach((e) => {
              this.items_macchine_impegnate.push(Object.assign(e));
            });
            this.dialog_impegni = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    async getworkorders() {
      this.request_counter++;
      const requestLayout = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutassociazioni",
          token: localStorage.user_token,
          id_profilo: localStorage.id_profilo,
          modulo: "SceltaWO",
        },
      };

      await this.$store
        .dispatch("api", requestLayout)
        .then((res) => {
          this.woQuery = res.data.result.associazioni[0].query;
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });

      if (this.woQuery == "") {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getworkordersutentegenerale",
            token: localStorage.getItem("user_token"),
            cod_commessa:
              this.filtroEM === "1" ? this.commessa.cod_commessa : "",
          },
        };

        await this.$store.dispatch("api", request).then((res) => {
          // Svuoto l'array che contiene le commesse in gestione
          this.items_consuntivo = [];

          // Popolo l'array che contiene i dati totali
          res.data.workorders.workorder.forEach((elem) => {
            /* Se ce l'ha, formatto la Produzione reale della fase
             * per convenienza di FE. */
            if (elem.pzhreale != null) {
              elem.pzhreale = elem.pzhreale.toFixed(2);
            }

            /* Se ce l'ha, formatto il tempo ciclo della fase
             * per convenienza di FE. */
            if (elem.tempo_ciclo != null) {
              elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
            }

            this.items_consuntivo.push(elem);
          });
        });
      } else {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "performquery",
            query_string: this.woQuery
              .replaceAll("\r", " ")
              .replaceAll("\n", " ")
              .replaceAll("\t", " "),
            token: localStorage.getItem("user_token"),
          },
        };

        await this.$store
          .dispatch("api", request)
          .then((res) => {
            this.items_consuntivo = res.data.result.Table;
          })
          .catch((err) => {
            console.error(err);
          });
      }
      this.request_counter--;
    },
    addMultipleToCarrello() {
      /* Controllo che nessun WO sia legato a una
       * macchina che compare più volte nella lista
       * (a meno che la macchina sia multicommessa). */
      let check_macchina_doppiata = false;
      for (
        let i = 0;
        i < this.$refs.WorkorderLayoutComponent.items_work_orders_sel.length;
        i++
      ) {
        if (
          this.$refs.WorkorderLayoutComponent.items_work_orders_sel.filter(
            (e) =>
              e.id_macchina ===
                this.$refs.WorkorderLayoutComponent.items_work_orders_sel[i]
                  .id_macchina &&
              this.$refs.WorkorderLayoutComponent.items_work_orders_sel[i]
                .multicommessa !== 1
          ).length > 1
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Impossibile aprire più WO su una stessa macchina (${this.$refs.WorkorderLayoutComponent.items_work_orders_sel[i].cod_macchina}) se questa non è multicommessa.`
          );
          check_macchina_doppiata = true;
          break;
        }
      }

      if (check_macchina_doppiata === true) {
        return;
      }

      // Se ho passato i controlli, eseguo il salvataggio.

      // Mi faccio un collettore di WO.
      const lista_wo = new Array();
      const wo_length =
        this.$refs.WorkorderLayoutComponent.items_work_orders_sel.length;
      this.$refs.WorkorderLayoutComponent.items_work_orders_sel.forEach(
        (wo) => {
          this.request_counter++;

          let request = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "getworkordersutente",
              token: localStorage.getItem("user_token"),
              id_commessa_dettaglio: wo.id_commessa_dettaglio,
            },
          };

          this.$store.dispatch("api", request).then((res) => {
            if (res.status === 200) {
              // Metto il WO dettagliato nella mia lista
              lista_wo.push(res.data.workorders.workorder[0]);

              // Se mi sono arrivati tutti i WO dettagliati che mi servivano...
              if (wo_length === lista_wo.length) {
                // Compongo un messaggio con il contenuto del row cliccato.
                let messaggio = {
                  detail: {
                    workorders: lista_wo,
                  },
                  src: null,
                };

                // Inserisco il messaggio in un evento custom.
                let evento = new CustomEvent("clicked_row_start_it", messaggio);

                /* Consegno alla mia destinazione l'evento con il
                 * contenuto del row che ho cliccato. */
                document
                  .getElementById("listener_Produzione2")
                  .dispatchEvent(evento);
              }
            }

            // Chiudo il dialog di conferma
            // Chiudo l'overlay di caricamento
            this.request_counter--;
          });
        }
      );

      /* Chiudo il dialog di conferma ed emetto un evento
       * per fare chiudere al padre il dialog dei consuntivi. */
      this.conferma_dialog_avvio_multiplo = false;
      this.$emit("inviato_elemento");
    },
    clickAvviaMultiploWO() {
      // Controllo che ci sia almeno un WO selezionato.
      if (
        this.items_consuntivo.filter((e) => e.selezionato == true).length == 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non è stato selezionato alcun Work Order."
        );
        return;
      }

      // Registro i WO selezionati e apro un dialog di conferma.
      this.$refs.WorkorderLayoutComponent.items_work_orders_sel = new Array();
      this.items_consuntivo
        .filter((e) => e.selezionato == true)
        .forEach((wo) => {
          this.$refs.WorkorderLayoutComponent.items_work_orders_sel.push(
            Object.assign({}, wo)
          );
        });

      // Controllo che nessuna macchina dei WO selezionati sia attualmente impegnata.
      if (
        this.$refs.WorkorderLayoutComponent.items_work_orders_sel.filter(
          (e) => e.macchina_impegnata === 1 && e.multicommessa === 0
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Alcune macchine risultano impegnate. Selezionare solo WO per macchine attualmente libere."
        );
        return;
      }

      /* Controllo che fra i WO da aggiungere non ce ne siano 2 della stessa fase
       * (non posso avviare contemporaneamente 2 fasi diverse della stessa commessa). */
      let chk_wo_stessa_commessa = false;
      this.$refs.WorkorderLayoutComponent.items_work_orders_sel.forEach(
        (wo) => {
          if (
            this.$refs.WorkorderLayoutComponent.items_work_orders_sel.filter(
              (e) => e.cod_commessa === wo.cod_commessa
            ).length > 1
          ) {
            chk_wo_stessa_commessa = true;
          }
        }
      );

      if (chk_wo_stessa_commessa === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non si possono avviare contemporaneamente più Work Order della stessa commessa."
        );
        return;
      }

      this.conferma_dialog_avvio_multiplo = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
      //this.salvaFiltriAttuali();
    },
    clickAvviaWO(item) {
      this.work_order_sel = Object.assign({}, item);
      this.conferma_dialog = true;
    },
    handleButtonClick(text, item) {
      if (text == "Aggiungi WO") {
        this.clickAvviaWO(item);
      }
    },
  },
};
</script>
<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
</style>